import axios, { AxiosResponse } from "axios";

import { authHeader } from "src/api/authHeader";
import { GenericObject } from "src/api/flowTypes";
import { pathJoin } from "src/api/paths";

const getLlmInferenceApiUrl = (flowBaseUrl: string, url: string): string => {
  return pathJoin("https://", flowBaseUrl, `/llm-inference/api/v1`, url);
};

export const llmInferenceApiGet = <ResponseT>(
  baseUrl: string,
  url: string,
  params?: GenericObject,
): Promise<AxiosResponse<ResponseT>> => {
  return axios.get<ResponseT, AxiosResponse<ResponseT>>(
    getLlmInferenceApiUrl(baseUrl, url),
    {
      ...authHeader(false),
      params: params,
    },
  );
};

export const llmInferenceApiPost = <ResponseT>(
  baseUrl: string,
  url: string,
  data: GenericObject,
): Promise<AxiosResponse<ResponseT>> => {
  return axios.post<ResponseT, AxiosResponse<ResponseT>>(
    getLlmInferenceApiUrl(baseUrl, url),
    data,
    {
      headers: {
        "Content-Type": "application/json",
        ...authHeader(false),
      },
    },
  );
};
